import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import TableData from "./components/TableData";
import { useTimeTable } from "../../data/useTimeTable";
import MDButton from "components/MDButton";

function TableKtelInfoHub() {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState("arrival");
  const [resetTrigger, setResetTrigger] = useState(0);
  const [loading, setLoading] = useState(false);

  const rows = useTimeTable(selectedType, {
    onStart: () => setLoading(true),
    onEnd: () => setLoading(false),
  });

  const handleTypeChange = (type) => {
    setSelectedType(type);
    setResetTrigger((r) => r + 1);
  };

 return (
    <Box sx={{ position: "relative" }}>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            zIndex: 10,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(3px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </Box>
      )}

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <MDButton
          variant={selectedType === "arrival" ? "contained" : "outlined"}
          onClick={() => handleTypeChange("arrival")}
        >
          {t("trafficMonitoring.infohub.arrival")}
        </MDButton>
        <MDButton
          variant={selectedType === "departure" ? "contained" : "outlined"}
          onClick={() => handleTypeChange("departure")}
        >
          {t("trafficMonitoring.infohub.departure")}
        </MDButton>
      </Stack>

      <TableData rows={rows} resetPageTrigger={resetTrigger} />
    </Box>
  );
}
export default TableKtelInfoHub;
